import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";
import QRTest from "../../../../assets/images/QR.jpg";
const ModalOffert = ({ open, setOpen, offert }) => {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 9999 }}
    >
      <DialogContent>
        <Box sx={{ display: "flex", gap: 3, justifyContent: "center" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 2,
            }}
          >
            <Typography component="div" variant="h6">
              {offert?.nameEstablishment ?? "Nombre del establecimiento."}
            </Typography>
            <Typography variant="h5" component="div" color="#e7ef7d">
              {offert?.discount ?? "Descuento."}
            </Typography>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{ color: "text.secondary" }}
            >
              {offert?.description ?? "Descripción de la oferta."}
            </Typography>
          </Box>
          {offert?.urlImg && (
            <Box>
              <img src={offert?.urlImg} alt="Qr de promoción" width={200} />
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={handleClose}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalOffert;
